import React, { useEffect, useState } from 'react';
import ProfileMFELoader from './components/ProfileMFELoader';
import DemoMFE from './Demo.mfe';
import { invokeProfileHostGetAccessToken } from './helpers/shouldUseHostedMFE';

type HostAuthState = 'idle' | 'pending' | 'failed';

export default function HostedMFE({ accessToken, configProps }: any) {
  const sharedWebView = (window as any)?.chrome?.webview || null;
  const profileHost = sharedWebView?.hostObjects?.ProfileHost;

  const [hostToken, setHostToken] = useState('');
  const [hostAuthState, setHostAuthState] = useState<HostAuthState>(() =>
    accessToken ? 'idle' : 'pending'
  );

  useEffect(() => {
    if (accessToken) {
      setHostAuthState('idle');
      setHostToken('');
      return;
    }

    const host = (window as any)?.chrome?.webview?.hostObjects?.ProfileHost;
    if (!host) {
      setHostAuthState('failed');
      return;
    }

    let cancelled = false;
    setHostAuthState('pending');
    invokeProfileHostGetAccessToken(host)
      .then((t: string) => {
        if (cancelled) {
          return;
        }
        const token = t.trim();
        if (token) {
          setHostToken(token);
          setHostAuthState('idle');
        } else {
          setHostAuthState('failed');
        }
      })
      .catch((err) => {
        if (cancelled) {
          return;
        }
        console.error('[HostedMFE] GetAccessToken failed', err);
        setHostAuthState('failed');
      });

    return () => {
      cancelled = true;
    };
  }, [accessToken]);

  if (hostAuthState === 'failed' && !accessToken) {
    return <DemoMFE configProps={configProps} />;
  }

  const displayToken = accessToken || hostToken;

  if (!displayToken) {
    return null;
  }

  if (sharedWebView) {
    configProps = {
      ...configProps,
      onClose: profileHost && profileHost.OnClose,
      onSave: (data: object) => {
        if (profileHost && profileHost.OnSave) {
          profileHost.OnSave(JSON.stringify(data));
        }
      },
    };
  }

  return <ProfileMFELoader accessToken={displayToken} {...configProps} />;
}
